
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class VDateRangePicker extends Vue {
  @Prop({ type: Boolean, default: true }) public required!: boolean;
  @Prop({ type: [Object, String], default: () => null }) public value!: { from: string; to: string } | string;
  @Prop({ type: [Array, Function] }) public allowedDates!: any[] | ((date?: any) => void);
  @Prop({ type: Number }) public maxRange!: number;
  @Prop({ type: Boolean, default: false }) public hideEnd!: boolean;

  public from: string = '';
  public fromMenu: boolean = false;
  public to: string = '';
  public toMenu: boolean = false;

  get range() {
    if (this.from && this.from.length > 0 && this.to && this.to.length > 0) {
      return {
        from: this.from,
        to: this.to,
      };
    }

    return null;
  }

  get fromAllowedDates() {
    return (date: string) => {
      const isAllowed = typeof this.allowedDates === 'function' ? this.allowedDates(date) : true;

      if (this.to && this.maxRange) {
        const maxFromDate = moment(this.to).subtract(this.maxRange, 'days');

        return (
          isAllowed && moment(date).isSameOrAfter(maxFromDate, 'day') && moment(date).isSameOrBefore(this.to, 'day')
        );
      }

      return isAllowed;
    };
  }

  get toAllowedDates() {
    return (date: string) => {
      const isAllowed = typeof this.allowedDates === 'function' ? this.allowedDates(date) : true;

      if (this.from && this.maxRange) {
        const maxToDate = moment(this.from).add(this.maxRange, 'days');

        return (
          isAllowed && moment(date).isSameOrAfter(this.from, 'day') && moment(date).isSameOrBefore(maxToDate, 'day')
        );
      }

      return isAllowed;
    };
  }

  public mounted() {
    this.init();
  }

  public init() {
    if (typeof this.value === 'string') {
      return;
    }

    if (this.value?.from) {
      this.from = moment(this.value.from).format('YYYY-MM-DD');
    }

    if (this.value?.to) {
      this.to = moment(this.value.to).format('YYYY-MM-DD');
    }
  }

  get fromRules() {
    if (this.required) {
      return 'required|date_before:@to';
    }

    return '';
  }

  get toRules() {
    if (this.required && !this.hideEnd) {
      return 'required';
    }

    return '';
  }

  @Watch('value')
  public onValueChange(val: Range, oldVal: Range) {
    if (val !== oldVal) {
      this.init();
    }
  }

  @Watch('range')
  @Emit('input')
  public onRangeChange() {
    return this.range;
  }
}
